var map = {
	"./print_0.png": "d+KF",
	"./print_1.png": "LYTy",
	"./print_2.png": "L8Xq",
	"./print_3.png": "HvAA",
	"./print_4.png": "AGG+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4aJV";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prints ^\.\/.*$
// module id = 4aJV
// module chunks = 0